<template>
	<div class="goodsTable">
		<el-table :data="goods" border style="width: 100%" ref="topicTable" :row-key="getRowKeys">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-row v-for="sp in props.row.specs" :key="sp.id" v-show="sp.show" class="specList">
						<el-col :span="2" v-if="$global.buyType!=0">
							<div style="opacity: 0;">{{"-"}}</div>
						</el-col>
						<el-col :span="6">
							<span class="proInfo">{{sp.color?(sp.color+"-"+sp.size):"默认"}}</span>
							<span class="proInfo">{{sp.unit+$global.unit+'/'+$global.pack}}</span>
							<span v-if="$common.hasLimits('stockInfo')">
								<span class="proInfo" :class="{'red':sp.stock-sp.needStockOutUnit<=0}">{{"库存:"+sp.stockDesc}}</span>
								<span class="proInfo" :class="{'red':sp.stock-sp.needStockOutUnit<=0}">{{"待发:"+sp.stockNSDesc}}</span>
								<span class="proInfo" :class="{'red':sp.stock-sp.needStockOutUnit<=0}">{{"可用:"+sp.stockCUDesc}}</span>
							</span>
						</el-col>
						<el-col :span="6" :offset="1" v-if="$global.buyType!=2" style="display:flex">
							<span class="normaltips" style="line-height:40px">{{$global.pack}}数:</span>
							<InNumber
								:datainfo="sp"
								:dataKey="'count'"
								@changeEnd="changeEnd($event,props.row,sp,'count')"
							></InNumber>
						</el-col>
						<el-col :span="6" v-if="$global.buyType!=1" style="display:flex">
							<span class="normaltips" style="line-height:40px">{{$global.unit}}数:</span>
							<InNumber
							:datainfo="sp"
							:dataKey="'num'"
							@changeEnd="changeEnd($event,props.row,sp,'num')"
						></InNumber>
						</el-col>
						<el-col :span="6" v-if="$global.showProductPrice">
							<span class="normaltips">单价(元):</span>
							<el-input 
							v-if="$global.userType==0"
							type="number"
							:min="0"
							style="width:160px"
							v-model="sp.price"
							@input="numChange($event,props.row,sp,'price')"
							/>
							<span class="proInfo" v-else>{{sp.price}}</span>
						</el-col>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column label="商品" width="60px">
				<template slot-scope="{ row }">
					<div>
						<el-image
                            style="width: 40px"
                            :src="row.img[0]"
                            :preview-src-list="row.img"
                        >
                            <template #error>
                                <div class="errorFonts_mini">暂无图片</div>
                            </template>
                        </el-image>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="编码" width="80px" prop="number">
			</el-table-column>
			<el-table-column label="产品名" min-width="180px">
				<template slot-scope="{ row }">
					<div class="goodsname"  @click="toGoodsInfo(row.id)">{{row.name}}</div>
				</template>
			</el-table-column>
			<el-table-column label="库存" prop="stockDesc" min-width="100px" v-if="$common.hasLimits('stockInfo')">
				<template slot-scope="{ row }">
					<div v-if="row.specs.length>1">-</div>
					<div v-else :class="{'red':row.specs[0].stock-row.specs[0].needStockOutUnit<=0}">
						<div>{{"库存:"+row.specs[0].stockDesc}}</div>
						<div>{{"待发:"+row.specs[0].stockNSDesc}}</div>
						<div>{{"可用:"+row.specs[0].stockCUDesc}}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="单位" width="80px">
				<template slot-scope="{ row }">
					<div v-if="row.specs.length>1">-</div>
					<div v-else>{{row.specs[0].unit+$global.unit+'/'+$global.pack}}</div>
				</template>
			</el-table-column>
			<el-table-column 
				:label="'规格'+($global.showProductPrice?'-单价(元)':'')+'-数量'"
				:min-width="($global.buyType==0?'520':'340')+'px'"
			>
				<template slot-scope="{ row }">
					<el-select v-if="row.specs.length>1" multiple collapse-tags v-model="row.sizeValue" placeholder="请选择" style="width: 240px" @change="specChange($event,row)">
						<el-option v-for="(item,index) in row.specs" :key="index" :label="$common.specTypeShow(item.color,item.size)" :value="index">
						</el-option>
					</el-select>
					<div v-else style="display:flex">
						<span style="line-height:40px;padding-right:5px">{{row.specs[0].color+"-"+row.specs[0].size}}</span>
						<el-input 
						:disabled="$global.userType!=0"
						type="number"
						:min="0"
						style="width:100px;padding-right:10px"
						v-model="row.specs[0].price"
						@input="numChange($event,row,row.specs[0],'price')"
						v-if="$global.showProductPrice"
						>
						</el-input>
						<InNumber
							:datainfo="row.specs[0]"
							:dataKey="'count'"
							v-if="$global.buyType!=2"
							:suffix="$global.pack"
							@changeEnd="changeEnd($event,row,row.specs[0],'count')"
						></InNumber>
						<div style="padding-right:10px" v-if="$global.buyType==0"></div>
						<InNumber
							:datainfo="row.specs[0]"
							:dataKey="'num'"
							v-if="$global.buyType!=1"
							:suffix="$global.unit"
							@changeEnd="changeEnd($event,row,row.specs[0],'num')"
						></InNumber>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="标签" min-width="150px" v-if="$global.useinstall!=1">
				<template slot-scope="{ row }">
					<el-tag v-for="(lb,index) in row.label" :key="index" effect="plain">{{lb}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="year" label="年度" width="60px" v-if="$global.useinstall!=1">
			</el-table-column>
		</el-table>
		<div style="margin-top: 15px;text-align: right;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[20, 50]" :page-size="sizeNumber" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber" :pager-count="5">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "goodsTable",
	props: {
		goods: {
			type: Array,
			default: function() {
				return [];
			}
		},
		currentPage:{
			type:Number,
			default:1,
		},
		sizeNumber:{
			type:Number,
			default:100,
		},
		totalNumber:{
			type:Number,
			default:100,
		},
	},
	data() {
		return {
			otherWeight: 80,
		};
	},
	mounted() {
		let screenWidth = document.body.clientWidth;
		if (screenWidth > 1100) {
			this.otherWeight = 160;
		}
	},
	methods: {
		numChange(e,dd,sp,val){
			this.$common.checkMoney(e,sp,val);
			this.$emit("updateNum",dd,sp.id);
		},
		changeEnd(e,dd,sp,val){
			sp[val] = e;
			this.$emit("updateNum",dd,sp.id);
		},
		handleSizeChange(val) {
			this.$emit("handleSizeChange",val);
		},
		handleCurrentChange(val) {
			this.$emit("handleCurrentChange",val);
		},
		toGoodsInfo(val) {
			// this.$router.push({
			// 	path: "/goodsInfo",
			// 	name: "商品详情",
			// 	query: {
			// 		id: val,
			// 	},
			// });
		},
		specChange(e,val){
			let count = 0;
			let gs = [];
			for(let i in val.specs){
				if(e.indexOf(parseInt(i))>=0){
					count++;
					gs.push(val.specs[i].id);
					val.specs[i].show = true;
				}else{
					val.specs[i].show = false;
				}
			}
			if(e.length>0){
				this.$global.goodsSelect[val.id] = gs;
			}else{
				this.$global.goodsSelect[val.id] = "";
			}
			
			if(count>0){
				this.$refs.topicTable.toggleRowExpansion(val, true);
			}else{
				this.$refs.topicTable.toggleRowExpansion(val, false);
			}
		},
		getRowKeys(row) {
			return row.id;
		},
		updateSpecShow(){
			this.goods.forEach(e => {
				if(e.sizeValue&&e.sizeValue.length>0){
					this.$refs.topicTable.toggleRowExpansion(e, true);
				}
			});
		}
	},
};
</script>


<style lang="scss" scoped>
.goodsname{
	width: 100%;
	height: 40px;
	line-height: 40px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	// cursor: pointer;
}
.el-tag{
	font-size: 14px;
	margin:3px;
}
.proInfo{
	line-height: 20px;
	font-size: 10px;
	margin-left: 5px;
}
.specList{
	padding: 10px;
}
</style>
